(function () {
  const accordions = document.querySelectorAll('.pdp-plain-accordion');
  if (!accordions.length) return;

  const getExtraHeight = () => (window.matchMedia('(max-width: 767px)').matches ? 10 : 25);

  const getTargetHeight = (el) => el.scrollHeight + getExtraHeight();

  const measureBodyHeight = (body) => getTargetHeight(body);

  const applyBodyTransition = (body) => {
    body.style.transition = 'height 0.6s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.25s ease, padding 0.38s ease, transform 0.38s ease';
  };

  function setBodyHeight(details, isOpenInit = false) {
    const body = details.querySelector('.accordion-body');
    if (!body) return;

    if (details.open || isOpenInit) {
      body.style.height = 'auto';
      body.style.padding = '8px 0 4px';
      body.style.opacity = '1';
      body.style.transform = 'translateY(0)';
    } else {
      body.style.height = '0px';
      body.style.padding = '0';
      body.style.opacity = '0';
      body.style.transform = 'translateY(-4px)';
    }
  }

  const openItem = (details, accordion) => {
    const body = details.querySelector('.accordion-body');
    if (!body) return;

    applyBodyTransition(body);
    const targetHeight = measureBodyHeight(body);
    details.open = true;
    body.style.height = '0px';
    body.style.padding = '0';
    body.style.opacity = '0';
    body.style.transform = 'translateY(-4px)';
    body.getBoundingClientRect();
    requestAnimationFrame(() => {
      body.style.height = `${targetHeight}px`;
      body.style.padding = '8px 0 4px';
      body.style.opacity = '1';
      body.style.transform = 'translateY(0)';
      body.addEventListener(
        'transitionend',
        (event) => {
          if (event.propertyName === 'height') {
            body.style.height = 'auto';
            body.style.padding = '8px 0 4px';
          }
        },
        { once: true }
      );
    });

    // Close siblings
    accordion.querySelectorAll('details').forEach((other) => {
      if (other !== details && other.open) {
        closeItem(other);
      }
    });
  };

  const closeItem = (details) => {
    const body = details.querySelector('.accordion-body');
    if (!body) return;
    if (details.dataset.closing === 'true') return;
    details.dataset.closing = 'true';

    applyBodyTransition(body);
    const currentHeight = body.getBoundingClientRect().height || measureBodyHeight(body);
    body.style.height = `${currentHeight}px`;
    body.style.padding = '8px 0 4px';
    body.style.opacity = '1';
    body.style.transform = 'translateY(0)';
    body.getBoundingClientRect();
    requestAnimationFrame(() => {
      body.style.height = '0px';
      body.style.padding = '0';
      body.style.opacity = '0';
      body.style.transform = 'translateY(-4px)';

      const finalizeClose = () => {
        delete details.dataset.closing;
        details.open = false;
        body.style.height = '0px';
        body.style.padding = '0';
        body.style.opacity = '0';
        body.style.transform = 'translateY(-4px)';
      };

      const timeoutId = setTimeout(finalizeClose, 800);

      body.addEventListener(
        'transitionend',
        (event) => {
          if (event.propertyName !== 'height') return;
          clearTimeout(timeoutId);
          finalizeClose();
        },
        { once: true }
      );
    });
  };

  accordions.forEach((accordion) => {
    accordion.querySelectorAll('details').forEach((details) => {
      // Initialize heights based on default open state
      setBodyHeight(details, details.open);

      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = details.open;
        if (isOpen) {
          closeItem(details);
        } else {
          openItem(details, accordion);
        }
      });
    });
  });
})();
